(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ao-application-page"] && !Shopify.designMode) return;
  try {
    
  const bindAssistOperatorsApplication = () => {
    document.querySelectorAll('[data-ao-application-page]:not([data-ao-bound])').forEach((section) => {
      section.dataset.aoBound = 'true';
      window.requestAnimationFrame(() => { section.dataset.aoMotionReady = 'true'; });
      const autofocusMessage = section.querySelector('[autofocus]');
      if (autofocusMessage) autofocusMessage.focus();

      const form = section.querySelector('form');
      if (form) {
        const trackStart = () => {
          window.aoTrack?.('application_start', { page_location: window.location.href });
        };
        form.addEventListener('focusin', trackStart, { once: true });
        form.addEventListener('input', trackStart, { once: true });
        form.addEventListener('submit', () => {
          window.aoTrack?.('application_submit', { page_location: window.location.href });
        });
      }

      const success = section.querySelector('[data-ao-application-success]');
      if (success) {
        const calendarUrl = success.dataset.calendarUrl;
        window.aoTrack?.('application_complete', { page_location: window.location.href });
        window.aoTrack?.('booking_start', { destination: calendarUrl });
        if (calendarUrl) {
          window.setTimeout(() => window.location.replace(calendarUrl), 450);
        }
      }
    });
  };

  bindAssistOperatorsApplication();
  document.addEventListener('shopify:section:load', bindAssistOperatorsApplication);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-header-v2"] && !Shopify.designMode) return;
  try {
    
  const bindAssistOperatorsHeaders = () => {
    document.querySelectorAll('[data-ao-sticky-header]:not([data-ao-bound])').forEach((header) => {
      header.dataset.aoBound = 'true';
      const desktopCta = header.querySelector('.ao-header-v2-cta');
      const mobileCta = header.querySelector('.ao-header-v2-mobile-cta');
      const progressBar = header.querySelector('[data-ao-scroll-progress]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let wasScrolled = false;
      let ticking = false;
      let lastPulseY = 0;
      let lastPulseAt = 0;
      let pulseTimeout;

      const pulseCta = () => {
        if (reducedMotion.matches) return;
        window.clearTimeout(pulseTimeout);
        [desktopCta, mobileCta].forEach((button) => {
          if (!button) return;
          button.classList.remove('is-breathing');
          void button.offsetWidth;
          button.classList.add('is-breathing');
        });
        pulseTimeout = window.setTimeout(() => {
          [desktopCta, mobileCta].forEach((button) => button?.classList.remove('is-breathing'));
        }, 760);
      };

      const updateHeader = () => {
        const currentY = window.scrollY;
        const isScrolled = currentY > 64;
        const now = window.performance.now();
        const pulseDistance = Math.max(620, window.innerHeight * 0.72);
        const documentRange = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        header.classList.toggle('is-scrolled', isScrolled);
        if (progressBar) progressBar.style.transform = `scaleX(${Math.min(1, currentY / documentRange)})`;
        if (isScrolled && (!wasScrolled || (Math.abs(currentY - lastPulseY) >= pulseDistance && now - lastPulseAt > 1100))) {
          pulseCta();
          lastPulseY = currentY;
          lastPulseAt = now;
        }
        wasScrolled = isScrolled;
        ticking = false;
      };

      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateHeader);
      }, { passive: true });

      header.querySelectorAll('.ao-header-v2-panel a').forEach((link) => {
        link.addEventListener('click', () => {
          const menu = link.closest('details');
          if (menu) menu.removeAttribute('open');
        });
      });

      const menu = header.querySelector('.ao-header-v2-menu');
      if (menu) {
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && menu.open) {
            menu.removeAttribute('open');
            menu.querySelector('summary')?.focus();
          }
        });
        document.addEventListener('click', (event) => {
          if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
        });
      }

      updateHeader();
    });
  };

  bindAssistOperatorsHeaders();
  document.addEventListener('shopify:section:load', bindAssistOperatorsHeaders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-homepage-v2"] && !Shopify.designMode) return;
  try {
    
  const bindAssistOperatorsV2 = () => {
    document.querySelectorAll('[data-ao-homepage-v2]:not([data-ao-bound])').forEach((root) => {
      root.dataset.aoBound = 'true';
      root.dataset.aoMotionReady = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const revealItems = root.querySelectorAll('[data-ao-reveal]');
      const motionSelector = '.ao-v2-meta-row, .ao-v2-intro-grid > *, .ao-v2-problem-grid article, .ao-v2-outcome-band, .ao-v2-slider, .ao-v2-step-grid article, .ao-v2-process-band, .ao-v2-plan-selector, .ao-v2-plan-card, .ao-v2-website-band, .ao-v2-details-intro, .ao-v2-accordion, .ao-v2-guide-signal, .ao-v2-guide-content, .ao-v2-application-signal, .ao-v2-application-content';
      revealItems.forEach((section) => {
        section.querySelectorAll(motionSelector).forEach((item, index) => {
          item.dataset.aoMotionItem = '';
          item.style.setProperty('--ao-motion-order', String(Math.min(index, 7)));
        });
      });

      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        revealItems.forEach((item) => observer.observe(item));
      }

      root.querySelectorAll('[data-ao-slider]').forEach((slider) => {
        const tabs = [...slider.querySelectorAll('[data-ao-slide-tab]')];
        const slides = [...slider.querySelectorAll('[data-ao-slide]')];
        const status = slider.querySelector('[data-ao-slide-status]');
        const previous = slider.querySelector('[data-ao-slide-prev]');
        const next = slider.querySelector('[data-ao-slide-next]');
        let activeIndex = 0;
        let timer;
        let touchStartX = 0;

        const stopTimer = () => window.clearTimeout(timer);
        const startTimer = () => {
          stopTimer();
          if (reducedMotion.matches || document.hidden) return;
          timer = window.setTimeout(() => showSlide(activeIndex + 1), 6500);
        };

        const showSlide = (index, focusTab = false) => {
          activeIndex = (index + slides.length) % slides.length;
          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === activeIndex;
            slide.hidden = !isActive;
            slide.classList.toggle('is-active', isActive);
          });
          tabs.forEach((tab, tabIndex) => {
            const isActive = tabIndex === activeIndex;
            tab.setAttribute('aria-selected', String(isActive));
            tab.tabIndex = isActive ? 0 : -1;
          });
          if (status) status.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
          if (focusTab) tabs[activeIndex].focus();
          startTimer();
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => showSlide(index));
          tab.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') { event.preventDefault(); showSlide(index + 1, true); }
            if (event.key === 'ArrowLeft') { event.preventDefault(); showSlide(index - 1, true); }
            if (event.key === 'Home') { event.preventDefault(); showSlide(0, true); }
            if (event.key === 'End') { event.preventDefault(); showSlide(slides.length - 1, true); }
          });
        });

        if (previous) previous.addEventListener('click', () => showSlide(activeIndex - 1));
        if (next) next.addEventListener('click', () => showSlide(activeIndex + 1));
        slider.addEventListener('mouseenter', stopTimer);
        slider.addEventListener('mouseleave', startTimer);
        slider.addEventListener('focusin', stopTimer);
        slider.addEventListener('focusout', startTimer);
        slider.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
        slider.addEventListener('touchend', (event) => {
          const distance = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(distance) < 48) return;
          showSlide(activeIndex + (distance < 0 ? 1 : -1));
        }, { passive: true });
        document.addEventListener('visibilitychange', () => document.hidden ? stopTimer() : startTimer());
        showSlide(0);
      });

      const planTabs = [...root.querySelectorAll('[data-ao-plan-tab]')];
      const planCards = [...root.querySelectorAll('[data-ao-plan-card]')];
      planTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const plan = tab.dataset.aoPlanTab;
          planTabs.forEach((item) => {
            const isActive = item === tab;
            item.setAttribute('aria-selected', String(isActive));
            item.tabIndex = isActive ? 0 : -1;
          });
          planCards.forEach((card) => { card.dataset.mobileActive = String(card.dataset.aoPlanCard === plan); });
        });
        tab.addEventListener('keydown', (event) => {
          const currentIndex = planTabs.indexOf(tab);
          let nextIndex = currentIndex;
          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % planTabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + planTabs.length) % planTabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = planTabs.length - 1;
          if (nextIndex === currentIndex) return;
          event.preventDefault();
          planTabs[nextIndex].click();
          planTabs[nextIndex].focus();
        });
      });

      root.querySelectorAll('[data-ao-accordion]').forEach((accordion) => {
        accordion.querySelectorAll('[data-ao-exclusive]').forEach((detail) => {
          detail.addEventListener('toggle', () => {
            if (!detail.open) return;
            accordion.querySelectorAll('[data-ao-exclusive]').forEach((other) => {
              if (other !== detail) other.removeAttribute('open');
            });
          });
        });
      });

      if (!reducedMotion.matches) {
        const parallaxItems = [...root.querySelectorAll('.ao-v2-slide-media img, .ao-v2-application-signal strong')];
        let parallaxTicking = false;
        const updateParallax = () => {
          parallaxItems.forEach((item) => {
            const rect = item.getBoundingClientRect();
            if (rect.bottom < -80 || rect.top > window.innerHeight + 80) return;
            const distance = window.innerHeight * 0.5 - (rect.top + rect.height * 0.5);
            const offset = Math.max(-18, Math.min(18, distance * 0.035));
            item.style.setProperty('--ao-parallax-y', `${offset}px`);
          });
          parallaxTicking = false;
        };
        window.addEventListener('scroll', () => {
          if (parallaxTicking) return;
          parallaxTicking = true;
          window.requestAnimationFrame(updateParallax);
        }, { passive: true });
        updateParallax();
      }
    });
  };

  bindAssistOperatorsV2();
  document.addEventListener('shopify:section:load', bindAssistOperatorsV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-private-enrollment"] && !Shopify.designMode) return;
  try {
    
  const bindAssistOperatorsEnrollment = () => {
    document.querySelectorAll('[data-ao-enrollment]:not([data-ao-bound])').forEach((section) => {
      section.dataset.aoBound = 'true';
      window.requestAnimationFrame(() => { section.dataset.aoMotionReady = 'true'; });

      section.querySelectorAll('.ao-enrollment-form').forEach((form) => {
        form.addEventListener('submit', async (event) => {
          if (!window.fetch) return;
          event.preventDefault();

          const button = form.querySelector('button[type="submit"]');
          const error = form.querySelector('[data-ao-enrollment-error]');
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          if (error) error.hidden = true;

          try {
            await fetch(`${section.dataset.clearUrl}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({})
            });

            const response = await fetch(`${form.action}.js`, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form)
            });

            if (!response.ok) throw new Error('Unable to start checkout');
            window.location.assign(section.dataset.checkoutUrl);
          } catch (checkoutError) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
            if (error) error.hidden = false;
          }
        });
      });
    });
  };

  bindAssistOperatorsEnrollment();
  document.addEventListener('shopify:section:load', bindAssistOperatorsEnrollment);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
